package com.alpha.showcase.common.ai

import androidx.room3.RoomDatabaseConstructor

internal actual object ImageSummaryDatabaseConstructor : RoomDatabaseConstructor<ImageSummaryDatabase> {
  actual override fun initialize(): ImageSummaryDatabase = com.alpha.showcase.common.ai.ImageSummaryDatabase_Impl()
}
